import { theme } from 'antd';
import React, { useEffect, useState } from 'react';
import { useManagePermittedRoles } from 'library/hooks';
import { useDispatch, useSelector } from 'react-redux';
import { selectSites } from 'reduxStore/sites/selectors';
import { Typography } from 'zui/Antd';
import { SelectFontSizeLG } from 'zui/Antd/Select';
import RemoveSiteCredentialModal from 'zComponents/molecules/RemoveSiteCredentialModal';
import { credentialsActions } from 'reduxStore/credentials/slice';
import { selectCredentialByID } from 'reduxStore/credentials/selectors';

const { Text } = Typography;

const EditSiteSelect = ({ credentialID }) => {
	const {
		token: { fontSizeLG, colorPrimary }
	} = theme.useToken();
	const dispatch = useDispatch();
	const isGlobalAdmin = useManagePermittedRoles('manageSiteAssignment');
	const canEdit = useManagePermittedRoles('managePersonSites');

	const sites = useSelector(selectSites);
	const credential = useSelector((state) => selectCredentialByID(state, credentialID));

	const siteIDs = credential?.sites?.map((s) => s.siteID) || [];

	const [editableSiteIDs, setEditableSiteIDs] = useState(siteIDs);
	const [removeModalVisible, setRemoveModalVisible] = useState(false);
	const [siteIDsToRemove, setSiteIDsToRemove] = useState([]);

	useEffect(() => {
		setEditableSiteIDs(siteIDs);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [credential?.sites]);

	const handleSelectChange = (newValue) => {
		const removed = editableSiteIDs.filter((id) => !newValue.includes(id));

		if (removed.length > 0) {
			setSiteIDsToRemove(removed);
			setRemoveModalVisible(true);
			return;
		}

		setEditableSiteIDs(newValue);
		dispatch(credentialsActions.updateCredentialSites({ credentialID, siteIDs: newValue }));
	};

	const options = sites.map((site) => ({
		label: site.name,
		value: site.siteID
	}));

	// Global admin can always edit; site admin only when they have multiple sites
	const showSelect = isGlobalAdmin || (canEdit && sites.length > 1);

	if (!showSelect) {
		const siteNames = siteIDs
			.map((id) => sites.find((s) => s.siteID === id)?.name)
			.filter(Boolean)
			.join(', ');
		return <Text style={{ fontSize: fontSizeLG }}>{siteNames || '-'}</Text>;
	}

	return (
		<>
			<SelectFontSizeLG
				mode='multiple'
				value={editableSiteIDs}
				onChange={handleSelectChange}
				placeholder='Select Sites'
				options={options}
				showSearch={false}
				virtual={false}
				maxTagCount={1}
				maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
				$tagColor={colorPrimary}
				style={{ minWidth: 228, maxWidth: 400 }}
				allowClear
			/>
			<RemoveSiteCredentialModal
				credentialID={credentialID}
				siteIDs={siteIDsToRemove}
				visible={removeModalVisible}
				setVisible={setRemoveModalVisible}
			/>
		</>
	);
};

export default EditSiteSelect;
